import { api } from '../configs/axiosConfigs';

export type ValuationSettings = {
  market_value_rate: number;
};

export const getValuationSettings = async () => {
  return await api('/valuation_settings');
};

export const updateValuationSettings = async (valuationSettings: ValuationSettings) => {
  return await api.put('/valuation_settings', { valuation_settings: valuationSettings });
};
